/**
 * SYSTEMIC PHASE RESOLVER (MEV5)
 * Analyzes the global endocrine state (Insulin + Glycogen + Fasting Duration)
 * to output a fluid 0-100 gauge score representing the metabolic cycle.
 */

export const SystemicPhaseResolver = {
    
    /**
     * Calculates the systemic score (0-100) and discrete biological phase.
     * @param insulin Current blood insulin level (uU/mL)
     * @param glycogenDebt Current muscle glycogen vacuum (grams)
     * @param hoursFasted Hours passed since the last meal ended
     */
    compute(insulin: number, glycogenDebt: number, hoursFasted: number) {
        let score = 50; 
        let label = 'DRAIN';
        let color = '#eab308';

        if (insulin >= 10.0) {
            // FED STATE (0 - 40)
            if (glycogenDebt < 50) {
                // PHASE 1: STORAGE (0-20)
                score = Math.max(0, 20 - (insulin - 10));
                label = 'STORAGE';
                color = '#ef4444'; 
            } else {
                // PHASE 2: REPAIR (20-40)
                const debtImpact = Math.min(20, glycogenDebt / 5);
                score = 20 + debtImpact - (insulin / 10);
                label = 'REPAIR';
                color = '#2ecc71'; 
            }
        } else {
            // FASTED STATE (40 - 100)
            const insMod = (10 - insulin) / 10; 
            
            if (hoursFasted < 12) {
                score = 40 + ((hoursFasted / 12) * 20 * insMod);
                label = 'DRAIN';
                color = '#eab308';
            } else if (hoursFasted < 18) {
                score = 60 + (((hoursFasted - 12) / 6) * 20);
                label = 'FAT BURN';
                color = '#f97316';
            } else if (hoursFasted < 24) {
                score = 80 + (((hoursFasted - 18) / 6) * 10);
                label = 'KETO';
                color = '#a855f7';
            } else {
                score = Math.min(100, 90 + (((hoursFasted - 24) / 48) * 10));
                label = 'RECYCLE';
                color = '#3b82f6';
            }
        }

        // Clamp final score
        score = Math.max(0, Math.min(100, score));
        return { score, label, color };
    }
};